import { ElMessage } from 'element-plus'

// 1. 修改 message.js 的导出方式
export const message = {
  success: (message) => {
    ElMessage.success(message)
  },
  error: (message) => {
    ElMessage.error(message)
  },
  warning: (message) => {
    ElMessage.warning(message)
  },
  info: (message) => {
    ElMessage.info(message)
  }
} 